module.exports = __webpack_public_path__ + "static/media/teacher20.e535893b.png";